declare const vwdata: any;
declare const window: any;

export enum AnalyticEvent {
  VehicleFormStepLoad = 'VWBasic_VehicleFormStep_Load',
  VehicleFormSubmissionSuccessMessageLoad = 'VWBasic_VehicleFormSubmissionSuccessMessage_Load',
  CTAClick = 'VWBasic_CTA_Click',
  LinkClick = 'VWBasic_Link_Click',
  VehicleFormCTAClick = 'VWBasic_VehicleFormCTA_Click',
  VWBasicVehicleStepLoad = 'VWBasic_VehicleStep_Load',
}
type Question = {
  Question: string;
  Answer: {
    value: string;
    type: 'single_select' | 'slider' | 'array' | 'input_text' | 'string';
  }[];
};
export interface AnalyticPayload {
  process?: {
    Name?: string;
    StepName: string;
    StepNumber: string;
  };
  product?: {
    Manufacturer: string;
    Name: string;
  };
  question?: Question | Question[];
  [key: string]: any;
}

const form = {
  FormName: 'EV FIT',
  FormType: 'enquiry',
} as const;

export function sendAnalyticPayload(
  payload: AnalyticPayload,
  event: AnalyticEvent = AnalyticEvent.VehicleFormStepLoad,
) {
  const {question, process, product, ...rest} = payload;
  const questionObject = question
    ? {
        id: 'Questionnaire EV FIT Form',
        version: '1',
        content: question,
      }
    : undefined;
  const finalPayload: Record<string, any> = {
    eventInfo: {
      eventAction: event,
      pageId: window.location.href,
      pageName: document.title,
    },
    environment: {
      language: 'en',
      country: 'AU',
    },
    form: {
      ...form,
      Questionnaire: {...questionObject},
      ...questionObject,
    },
    process: {
      Name: 'EV FIT',
      ...process,
    },
    ...rest,
  };

  if (!questionObject) {
    delete finalPayload.form.Questionnaire;
  }

  if (payload.product) {
    finalPayload.product = payload.product;
  }

  window.evForm = finalPayload;

  console.log('sendAnalyticPayload', finalPayload);
  if (typeof vwdata === 'undefined') return;
  vwdata?.push(finalPayload);
}
